
<!--start section header-->
<header class="head d-flex justify-content-center align-items-center">

   <div class="head-caption text-center">
    <h1>MENU</h1>
    <p>Tomato is a delicious restaurant website template</p>
   </div>

</header>
<!--end section header-->

<!--start section overlay-->
<section class="py-5 overlay">
    <div class=" text-center"> 
        <h1>OVERLAY</h1>
        <p class="text-muted">These fine folks trusted the award winning restaurant.</p>
        <div class="mini m-auto"></div>
     </div> 
     <div class="d-flex justify-content-center overlay-caption py-5">
         <h5 (click)="all()">ALL</h5>
         <h5 (click)="starters()">STARTERS</h5>
         <h5 (click) ="breakfasts()">BREAKFAST</h5>
         <h5 (click) ="lunchs()">LUNCH</h5>
         <h5 (click) ="dinners()">DINNER</h5>
         <h5 (click) ="desserts()">DESSERTS</h5>
     </div>

     <div class="container">
         <div id="overlay" class="row" (click) = "naviget()">

            
             <div class="col-lg-4 col-md-6"  >

               <div class="overlay-menu text-center position-relative mb-4">
                   <img src="assets/images/food1.jpg" class="img-fluid" alt="food">
                   <div class="menu-tags">
                       <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                       <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                       <div class="brdr"></div>
                       <div class="price"><span>$</span> 14.95</div>
                       
                   </div>
                     <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                      <span class="pb-2">+</span></div>
                </div>
                
             </div>
             <div class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative mb-4">
                    <img src="assets/images/food2.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                 </div>
                 
              </div><div class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative mb-4">
                    <img src="assets/images/food3.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                 </div>
                 
              </div><div class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative mar-bottom">
                    <img src="assets/images/food4.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                 </div>
                 
              </div>
              <div class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative mar-bottom">
                    <img src="assets/images/food5.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                 </div>
                 
              </div>
              <div class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative mar-bottom">
                    <img src="assets/images/food6.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
              </div>
              

         </div>

         <div class="row" id="starters">


            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food6.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food3.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food4.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
            <div  class="col-lg-4 col-md-6 mt-4">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food5.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>

        </div>

        <div class="row" id="breakfast">


            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food2.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food4.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food1.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
           

        </div>

        <div class="row" id="lunch">


            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food6.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food5.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
            
           

        </div>
        <div class="row" id="dinner">


            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food5.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
            
           

        </div>
        <div class="row" id="dessert">


            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food3.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
            <div  class="col-lg-4 col-md-6">

                <div class="overlay-menu text-center position-relative">
                    <img src="assets/images/food2.jpg" class="img-fluid" alt="food">
                    <div class="menu-tags">
                        <h4 class="pt-5">ENGLISH-ASPARAGUS</h4>
                        <P>Asparagus, hens egg, toasted<br> sunflower seeds, Spenwood cheese</P>
                        <div class="brdr"></div>
                        <div class="price"><span>$</span> 14.95</div>
                        
                    </div>
                      <div class="circle d-flex justify-content-center align-items-center rounded-circle">
                       <span class="pb-2">+</span></div>
                </div>
                 
            </div>
            
           

        </div>

         


     </div>
     
</section>
<!--end section overlay-->

<!--start section insta-->
<section class="container py-4">
    <div class="row insta-caption">
    
        <div class="col-md-3 sub-caption">
            <p>SUBSCRIBE</p>
        </div>
        <div class="col-md-8">
         <p class="text-muted p">Get updates about new dishes and upcoming events</p>
     </div>
       
       </div>
       <div class="registers d-flex justify-content-end pb-4">
         <input class="inpt-caption mr-4" type="email" placeholder=" Your Email Address ">
         <button type="submit" class="register"><i class="fas fa-chevron-right fa-1x"></i></button>
       </div>
</section>
<!--end section insta-->




